import React from 'react';
import { Helmet } from 'react-helmet-async';
import { SITE_URL } from '../../constants';

const DEFAULT_IMAGE = '/logo512.png';

// Per-page <head> tags. The build prerenders public pages, so these end up in
// the static HTML that search engines and AI crawlers read.
function Seo({ title, description, path, image = DEFAULT_IMAGE, type = 'website', noindex = false, jsonLd }) {
    const url = path !== undefined ? `${SITE_URL}${path}` : undefined;
    const imageUrl = image.startsWith('http') ? image : `${SITE_URL}${image}`;
    const schemas = jsonLd ? [].concat(jsonLd) : [];

    return (
        <Helmet>
            <title>{title}</title>
            {description && <meta name="description" content={description} />}
            {noindex && <meta name="robots" content="noindex" />}
            {url && <link rel="canonical" href={url} />}

            <meta property="og:site_name" content="Screenplayer" />
            <meta property="og:type" content={type} />
            <meta property="og:title" content={title} />
            {description && <meta property="og:description" content={description} />}
            {url && <meta property="og:url" content={url} />}
            <meta property="og:image" content={imageUrl} />
            <meta name="twitter:card" content="summary_large_image" />
            <meta name="twitter:site" content="@screendj" />

            {schemas.map((schema, index) => (
                <script key={index} type="application/ld+json">{JSON.stringify(schema)}</script>
            ))}
        </Helmet>
    );
}

export default Seo;
